<!-- Frequency Display Component - Replica of sub-route-periodicity frequency column -->
<div class="frequency-display-container">
  <div class="frequency-content">
    <!-- Calendar Button -->
    <button 
      mat-icon-button 
      (click)="openModalCalendar()"
      class="calendar-button"
      matTooltip="📅 Abrir calendario para gestionar frecuencias de visita"
      matTooltipPosition="above">
      <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
    </button>
    
    <!-- Frequency Information -->
    <div class="frequency-info">
      <!-- Days Display -->
      <span 
        class="days-display"
        [matTooltip]="getDaysTooltip()"
        matTooltipPosition="above">
        {{ displayDays }}
      </span>
      
      <!-- Frequency Counters -->
      <div class="frequency-counters">
        <!-- Day Frequencies Count (Weekly) -->
        <span 
          class="frequency-counter"
          matTooltip="📊 Frecuencias semanales (Weekly) - Días fijos de la semana"
          matTooltipPosition="above">
          D({{ dayFrequenciesCount }})
        </span>
        
        <!-- Custom Frequencies Count (with clickable button if has custom frequencies) -->
        <button 
          mat-button 
          color="primary"
          [disabled]="!hasCustomFrequencies"
          (click)="openCustomFrequenciesModal()"
          class="custom-frequency-button"
          [matTooltip]="getCustomFrequenciesTooltip()"
          matTooltipPosition="above">
          A({{ customFrequenciesCount }})
        </button>
      </div>
    </div>
  </div>
</div>